<template>
  <section class="table-sampler-validation-chemical">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Amostra representativa</label>
        <select type="text" class="form-control" v-model="model.exposition" required>
          <option value="Sim" selected>Sim</option>
          <option value="Não">Não</option>
        </select>
      </d-col>
      <d-col cols="9">
        <label>Avaliação pessoal do trabalhador sobre exposição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Avaliação"
          v-model="model.avaliation"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Tipo de amostra</label>
        <select type="text" class="form-control" v-model="model.sample_type" required>
          <option value="Abaixo do normal" selected>Abaixo do normal</option>
          <option value="Normal">Normal</option>
          <option value="Acima do normal">Acima do normal</option>
        </select>
      </d-col>
      <d-col cols="9">
        <label>Justifique</label>
        <input
          type="text"
          class="form-control"
          placeholder="Justifique"
          v-model="model.justify"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <h6 class="col-12 my-3">Calibração</h6>
      <d-col cols="3">
        <label>Verificação inicial <small>(L/min)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Verificação inicial"
          v-model="model.varification_initial"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Verificação final <small>(L/min)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Verificação inicial"
          v-model="model.varification_final"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Variação de vazão <small>(%)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Verificação inicial"
          v-model="model.variation"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Calibração aceitável</label>
        <select type="text" class="form-control" v-model="model.calibration" required>
          <option value="Sim" selected>Sim</option>
          <option value="Não">Não</option>
        </select>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { CHEMICAL_VALIDATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Validation-Chemical',
  props: {
    validation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(CHEMICAL_VALIDATION),
    };
  },
  methods: {
    setModel() {
      if (this.validation) {
        this.model = this.validation;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:validation', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
